import React from 'react'
import PropTypes from 'prop-types'

import InfoDivider from 'Components/InfoDivider'
import {
  _VerticalTimeLineElement,
  _VerticalTimeLineHeader,
  _Date,
  _DisplayChildrenLarge,
  _DisplayChildrenSmall,
  _VerticalTimelineElementContent,
  _ListedAndSold,
} from './styles'

const VerticalTimelineElementSimple = ({
  children,
  className,
  contentStyle,
  date,
  id,
  listed,
  soldRentCount,
  style,
  isLastElement,
  status,
  isAddressPage = false,
}) => (
  <_VerticalTimeLineElement
    id={id}
    growMargin={!isLastElement}
    style={style}
    className={className}
    isAddressPage={isAddressPage}
  >
    <React.Fragment>
      <_VerticalTimelineElementContent
        noChildren={children === ''}
        style={contentStyle}
      >
        <_VerticalTimeLineHeader visible>
          <_Date>{date}</_Date>
          <_ListedAndSold>
            {' '}
            - {listed} Listed<InfoDivider />
            {soldRentCount} {status}
          </_ListedAndSold>
        </_VerticalTimeLineHeader>
        <_DisplayChildrenLarge>
          {children}
        </_DisplayChildrenLarge>
      </_VerticalTimelineElementContent>
      <_DisplayChildrenSmall>
        {children}
      </_DisplayChildrenSmall>
    </React.Fragment>
  </_VerticalTimeLineElement>
)

VerticalTimelineElementSimple.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  contentStyle: PropTypes.shape({}),
  date: PropTypes.node,
  iconStyle: PropTypes.shape({}),
  id: PropTypes.string,
  style: PropTypes.shape({}),
  listed: PropTypes.number,
  isLastElement: PropTypes.bool,
  status: PropTypes.string,
  soldRentCount: PropTypes.number,
  isAddressPage: PropTypes.bool,
}

VerticalTimelineElementSimple.defaultProps = {
  children: '',
  className: '',
  contentStyle: null,
  iconStyle: null,
  id: '',
  style: null,
  date: '',
  listed: 0,
  soldRentCount: 0,
  isLastElement: false,
  status: 'Sold',
}

export default VerticalTimelineElementSimple
